export default __webpack_public_path__ + "static/media/2022title.0663e3e8.jpeg";